import { Locales } from '../../config/constants';

export const localeToDatePlaceholder: Record<Locales, string> = {
    [Locales.en]: 'mm/dd/yyyy',
    [Locales.fr]: 'jj/mm/aaaa',
};

export const localeToDateFormat: Record<Locales, string> = {
    [Locales.en]: 'MM/dd/yyyy',
    [Locales.fr]: 'dd/MM/yyyy',
};

export const localeToDateTimeFormat: Record<Locales, string> = {
    [Locales.en]: 'LLLL dd u HH:mm',
    [Locales.fr]: 'dd LLLL u HH:mm',
};
